import {Model} from 'common'
import './detail'
Model.define('ycctrl.projectdef', {
  proxy: {
    get: '/cpu-project-def/ycctrl/projectdef/detail/:id',
    post: '/cpu-project-def/ycctrl/projectdef/detail'
  },
  meta: {
    userId: '',
    userName: '',
    orgId: '',
    orgName: '',
    code: '',
    name: '',
    deptId: '',
    deptName: '',
    enterpriseId: '',
    enterpriseName: '',
    extFields: '',
    failbidReason: '',
    failbidSegment: '',
    failbidTime: '',
    hasWorkFlows: '',
    id: '',
    modifier: '',
    openPassword: '',
    openTenderType: '',
    purOrgId: '',
    scoreMemo: '',
    signEndTime: '',
    signTimeEnd: '',
    sortItemMap: '',
    psnId: '',
    psnCode: '',
    psnName: '',
    evaGroupID: '',
    evaGroupName: '',
    statusShow: '',
    // sugSupplierList: '',
    supervisePsnId: '',
    supervisePsnName: '',
    supplierBidList: '',
    sysVersion: '',
    talksEndTime: '',
    talksRound: '',
    talksTimeEnd: '',
    ts: '',
    bidEndTime: '',
    bidTimeEnd: '',
    createTime: {type: 'date'},
    modifiedtime: {type: 'date'},
    creator: '',
    billcode: {
      // type: 'integer',
      required: true,
      nullMsg: '编号不能为空!',
      maxLength: 20,
      maxLengthMsg: '编号长度不大于20'
    },
    subject: {
      type: 'string',
      required: true,
      nullMsg: '标题不能为空!'
    },
    purOrgName: {
      type: 'string',
      required: true,
      nullMsg: '采购组织不能为空!'
    },
    purPsnId: '',
    purPsnName: {
      type: 'string',
      required: true,
      nullMsg: '采购负责人不能为空!'
    },
    purBudgetMny: {
      type: 'integer'
    },
    exceptStartTime: {type: 'date'},
    exceptEndTime: {type: 'date'},
    supplierMinNum: {
      type: 'string',
      required: true,
      nullMsg: '参与采购数量不能为空!',
      validType: 'integer'
    },
    purchaseType: {
      type: 'string',
      required: true,
      nullMsg: '采购方式不能为空!'
    },
    singleTenderReason: '',
    isCtrlOpen: '',
    ctrlOpenTime: {type: 'date'},
    hasSuperviseDept: '',
    isExpertReview: '',
    reviewMethodMode: '',
    reviewMethodScore: '',
    isPurUrgent: '',
    urgentReason: '',
    defProjectPsnId: '',
    defProjectPsnName: '',
    defProjectPsnTel: '',
    defProjectPsnEmail: '',
    rowStatus: '',
    status: '',
    statusName: '',
    psnCorpId: '',
    psnCorpName: '',
    psnDeptId: '',
    psnDeptName: '',
    statusNameShow: '',
    dr: '',
    indicatorMaxScore: '',
    indicatorMesc: '',
    scoreStandard: '',
    maxScore: '',
    minScore: '',
    includeMax: 0,
    includeMin: 0,
    operation: '',
    supplyabilityId: '',
    supplyabilityName: '',
    comItems: [{
      'value': '1',
      'name': '合格'
    }, {
      'value': '0',
      'name': '不合格'
    }],
  },
  associations: {
    detailList: {
      type: 'hasMany', // hasMany
      model: 'ycctrl.detail'
    }
  }
})

export default Model.create('ycctrl.projectdef')



// WEBPACK FOOTER //
// ./src/data/model/projectdef/index.js